/**
 * Calls /api/photo-actions to extract tasks/events from a photo.
 */

import { authenticatedFetch } from '@/lib/services/AuthenticatedFetchService';
import type { PhotoActionsResponse } from '@/types/photo-actions';

export class PhotoActionService {
  static async extract(imageDataUrl: string): Promise<PhotoActionsResponse> {
    const today = new Date();
    const todayDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

    const response = await authenticatedFetch.fetch('/api/photo-actions', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ image: imageDataUrl, todayDate }),
    });

    if (!response.ok) {
      const body = await response.json().catch(() => ({}));
      const message = (body as { error?: string }).error ?? `Request failed: ${response.status}`;
      throw new Error(message);
    }

    return (await response.json()) as PhotoActionsResponse;
  }
}
